module.exports = __webpack_public_path__ + "static/media/logo_alt.8bea0f92.png";